import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useProgramsComparisonStore = defineStore('programsComparison', () => {
    const all = ref({ data: [] });

    const reset = () => {
        all.value = { data: [] };
    };

    const actions = {
        search: (params) => axios.get('/api/v1/programs-comparison', { params }),
        store: (params) => axios.post('/api/v1/programs-comparison', params),
        update: (params) => axios.patch('/api/v1/programs-comparison/' + params.hash, params),
        destroy: (params) => axios.delete('/api/v1/programs-comparison/' + params.hash),
    };

    return {
        all,
        reset,
        ...actions,
    };
});
